/*
 * Shared add-to-cart for the custom sections: adds items, then opens the theme's cart drawer
 * (Theme settings > Cart > type "drawer"), or goes to the cart page when there is no drawer
 * (or on the cart page itself). Also makes the landing/product buy forms (data-fwl-ajax) use it.
 */
(function () {
  if (window.fwlCart) return;

  function opened() {
    try {
      var onCartPage = window.theme && theme.pageType === 'cart';
      if (!onCartPage && window.theme && theme.Cart && theme.Cart.prototype._onProductAdded && document.querySelector('#sidebar-cart')) {
        theme.Cart.prototype._onProductAdded();
        return;
      }
    } catch (e) {}
    window.location.href = (window.routes && window.routes.cartUrl) || '/cart';
  }

  function add(items) {
    return fetch(((window.routes && window.routes.cartAddUrl) || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
        opened();
        return data;
      });
    });
  }

  window.fwlCart = { add: add, opened: opened };

  // Buy forms on the landing and product pages: add without leaving the page.
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-fwl-ajax]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    if (button) button.disabled = true;
    add([{ id: Number(id.value), quantity: Number(qty ? qty.value : 1) || 1 }])
      .catch(function () { form.submit(); })   // fall back to the normal form post
      .then(function () { if (button) button.disabled = false; });
  });
})();
